import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store } from "./modules/store";
import { Provider } from "react-redux";
import "./i18n";
import { CurrencyContext } from "./context/currency.context";
import { Currency } from "./models/currency";
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <CurrencyContext.Provider value={Currency}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </CurrencyContext.Provider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
